module.exports = "<p>\n  base-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/commons/base-page/base-page.component.html
// module id = ../../../../../src/app/views/commons/base-page/base-page.component.html
// module chunks = main